angular.module("app").filter('filterPagesTableColumns', function() {
    var neededColumns = {
        step1: {
            'title': true,
            'name': true,
         //   'author': true,
            'changed_at': true,
            'created_at': true,
            id: true
        },
        step2: {
            'image': true,
            'categories': true,
            'end_date': true,
            'start_date': true,
            'changed_at': true,
            'created_at': true,
            'title': true,
         //   'author': true,
            'page_id': true,
            'parent_id': true,
            'order': true,
            'click_count': true,
            id: true
        }

    };
    return function (pagesTable, step, clickCountState) {
        if(!pagesTable){
            return;
        }
        pagesTable = angular.copy(pagesTable);
        var pagesTableLength = pagesTable.length;
        for(var i = 0; i < pagesTableLength; ++i) {
            var row = pagesTable[i];
            for(var col in row) {
                if(row.hasOwnProperty(col) && !neededColumns["step" + step][col]){
                    delete row[col];
                }
            }
            row["date"] = (row['changed_at'] && row['changed_at'] !== "0000-00-00 00:00:00") ? row['changed_at'] : row['created_at'];
            delete row['changed_at'];
            delete row['created_at'];
            if (row['parent_id'] !== undefined){
                row['page_id'] = row['parent_id'];
                delete row['parent_id'];
            }
            if (row.categories !== undefined){
                row.categories = row.categories.reduce(function (prev, curr) {
                    if (prev === "") {
                        return prev + curr.title;
                    } else {
                        return prev + "," + curr.title;
                    }
                }, "");
            }
            if (step === 1) {
               pagesTable[i]  ={
                   name: row.name,
                   nameNoTrans: row.name,
                   title: row.title,
                //   author: row.author,
                   date: row.date,
                   id: row.id
               }
            } else {
                pagesTable[i]  ={
                    title: row.title,
                    image: row.image,
                 //   author: row.author,
                    start_date: row.start_date,
                    end_date: row.end_date,
                    categories: row.categories,
                    date: row.date,
                    click_count: (clickCountState && clickCountState.show) ?row.click_count : 0,
                    page_id: row.page_id,
                    id: row.id,
                    order: row.order
                };
                /*if (row.author === undefined) {
                    delete pagesTable[i].author;
                }*/
                if (row.categories === undefined) {
                    delete pagesTable[i].categories;
                }
                if (row.click_count === undefined || (clickCountState && clickCountState.remove)) {
                   delete pagesTable[i].click_count;
                }
            }
        }
        return pagesTable;

    }
});
